document.addEventListener("DOMContentLoaded", function () {
  const allBrandLi = document.querySelectorAll(".collection-li");
  const quickBuyWrapper = document.querySelector(".quickBuyWrapper");
  if (!quickBuyWrapper) return;

  const addPcCodeToCart = Boolean(quickBuyWrapper.dataset.addPcCodeToCart);
  const main = document.querySelector(".quickBuyWrapper main");
  const sideBar = document.querySelector(".quickBuyWrapper #sideBar");
  const viewAllBrands = document.querySelector(".viewAllBrands");
  const viewAllBrandsSpan = document.querySelector(".viewAllBrandsSpan");
  const loadingWrapperParent = document.querySelector(".loadingWrapperParent");
  const quickBuyAtc = document.querySelector("#quickBuyAtc");

  const productPrice = quickBuyWrapper.dataset.productPrice;
  const selectBodyCta = quickBuyWrapper.dataset.selectBodyEngine;
  const goToPP = quickBuyWrapper.dataset.goToPp;
  const outOfStockText = quickBuyWrapper.dataset.outOfStock || "Out of Stock";

  // Ham nitelik verisini güvenle alıyoruz
  const rawOutOfStockAttr = quickBuyWrapper.getAttribute("data-out_of_stock_pc_code_arr") || "";
  
  // Güvenli dizi dönüşümü: Boşluklar temizlenir, harfler küçültülür, boş veriler elenir
  const outOfStockArr = rawOutOfStockAttr
    .split(",")
    .map(item => item.trim().toLowerCase())
    .filter(item => item !== "");

  // console.log("Aktif Stok Dışı Kodları:", outOfStockArr);

  allBrandLi.forEach((brandLi) => {
    brandLi.addEventListener("click", (e) => {
      const buttonElement = brandLi.querySelector(".collection-button") || e.target;
      // collection handle from Liquid; the label is only a fallback
      const clickedBrand = buttonElement.dataset.handle || buttonElement.textContent
        .trim()
        .toLowerCase()
        .replace(/ /g, "-");

      sideBar.style.display = "none";
      loadingWrapperParent.style.display = "flex";

      fetchProductsForBrand(clickedBrand);
    });
  });

  const fetchProductsForBrand = (brandName) => {
    // limit=250: the default page is 30 products (Chevrolet has more)
    fetch(`${Shopify.routes.root}collections/${encodeURIComponent(brandName)}/products.json?limit=250`)
      .then((response) => response.json())
      .then((data) => {
        quickBuyWrapper.style.backgroundImage = "none";
        quickBuyWrapper.style.backgroundColor = "#212121";
        return data.products;
      })
      .then((dataProducts) => {
        const scrollTop = {
          top: 100,
          behavior: "smooth",
        };

        window.scrollTo(scrollTop);
        loadingWrapperParent.style.display = "none";
        main.style.display = "grid";
        viewAllBrands.style.display = "flex";
        
        viewAllBrandsSpan.addEventListener("click", () => {
          main.style.display = "none";
          sideBar.style.display = "grid";
          viewAllBrands.style.display = "none";
          defaultBgImage();
        });

        displayProducts(dataProducts);
      })
      .catch((error) => {
        console.error("Error fetching products:", error);
      });
  };

  const displayProducts = (products) => {
    let combinedHTML = "";

    products.forEach((product) => {
      // Varyantları stok dışı listesine göre filtreleme (Harf duyarsız ve boş liste korumalı)
      const availableVariants = product.variants.filter((variant) => {
        if (outOfStockArr.length === 0) return true;

        const variantTitleLower = variant.title.toLowerCase();
        return !outOfStockArr.some(code => variantTitleLower.includes(code));
      });

      const hasVariants = availableVariants.length > 0;
      const buttonCTA = hasVariants ? selectBodyCta : outOfStockText;
      const buttonDisabled = hasVariants ? "" : "disabled style='opacity: 0.6; cursor: not-allowed;'";

      const productHTML = `
        <div class="product-card-body">
          <span class="addedProduct">ADDED</span>
          <div class="product-card-imgParent">
            <img width="300" height="300" loading="lazy" src="${product.images[0].src}">
            <span class="product-card-price">${productPrice}</span>
          </div>
          <h3 class="product-card-title">${product.title}</h3>
          
          <button class="product-card-view-variants" ${buttonDisabled}>${buttonCTA}</button>
          
          <ol class="product-card-variantsParent" style="display: none;">
            ${availableVariants.map((variant) => {
              return `
                <li>
                  <button class="c-btn-add-to-cart atcBtnDrawer"
                    data-atc="${variant.id}"
                    data-selection="${variant.title.split("/")[0]} / ${variant.title.split("/")[3]}"
                    data-variant-title="${variant.title}"
                  >
                    <span class="variantYear">${variant.title.split("/")[3]}</span> 
                    <span class="variantEngine">${variant.title.split("/")[4]}</span>
                  </button>
                </li>
              `;
            }).join("")}
          </ol>

          <a class="product-card-goTo" href="${Shopify.routes.root}products/${product.handle}"> ${goToPP} </a>
        </div>
      `;

      combinedHTML += productHTML;
    });

    // HTML çıktısını tek seferde DOM'a basıyoruz (Hafıza referans koruması)
    main.innerHTML = combinedHTML;

    // Varyant Listesi Göster/Gizle Butonlarının Yönetimi
    const buttons = main.querySelectorAll(".product-card-view-variants");
    buttons.forEach((button) => {
      if (button.hasAttribute('disabled')) return;

      button.addEventListener("click", function () {
        const cardBody = this.closest(".product-card-body");
        const variantsList = cardBody ? cardBody.querySelector(".product-card-variantsParent") : null;
        
        if (!variantsList) return;

        const isFlex = variantsList.style.display === "flex";
        variantsList.style.display = isFlex ? "none" : "flex";

        if (variantsList.childElementCount < 7) {
          variantsList.style.justifyContent = "center";
        }
      });
    });

    // Varyant Satırlarına Tıklama ve Sepete Ekleme Yönetimi
    const allLiElement = main.querySelectorAll(".product-card-variantsParent li");
    allLiElement.forEach((li) => {
      li.addEventListener("click", function (event) {
        const buttonElement = li.querySelector("button");
        if (!buttonElement) return;

        const dataId = buttonElement.getAttribute("data-atc");
        const dataSelection = buttonElement.getAttribute("data-selection");
        const currentCard = event.target.closest(".product-card-body");
        if (!currentCard) return;

        const addedProduct = currentCard.querySelector(".addedProduct");

        if (addedProduct) {
          addedProduct.style.display = "flex";
          setTimeout(() => {
            addedProduct.style.display = "none";
          }, 2000);
        }

        defaultBgImage();
        
        const parentVariantsList = event.target.closest(".product-card-variantsParent");
        if (parentVariantsList) parentVariantsList.style.display = "none";

        setTimeout(() => {
          main.style.display = "none";
          sideBar.style.display = "grid";
          viewAllBrands.style.display = "none";
        }, 2000);

        if (addPcCodeToCart) {
          const variantTitle = buttonElement.dataset.variantTitle;
          const pcCode = variantTitle.split("/")[0].trim().toLowerCase();
          const url = `${Shopify.routes.root}products/${pcCode}.js`;
          
          fetch(url)
            .then((res) => res.json())
            .then((productData) => {
              const variant = productData.variants[0];
              const parsedTitle = variantTitle.split("/").map((item) => item.trim());
              parsedTitle.shift();
              quickBuyAtc.dataset.atc = variant.id;
              quickBuyAtc.dataset.selection = parsedTitle.join(" / ");
              quickBuyAtc.click();
            })
            .catch(err => console.error("Error fetching fluid product json:", err));
        } else {
          quickBuyAtc.dataset.atc = dataId;
          quickBuyAtc.dataset.selection = dataSelection;
          quickBuyAtc.click();
        }
      });
    });
  };

  const defaultBgImage = () => {
    quickBuyWrapper.style.backgroundColor = "none";
    if (window.innerWidth > 768) {
      quickBuyWrapper.style.backgroundImage =
        "url('//pedalcommander.com/cdn/shop/t/187/assets/xd-hero_bg.webp')";
    } else {
      quickBuyWrapper.style.backgroundImage =
        "url('//pedalcommander.com/cdn/shop/t/163/assets/xd-hero-mobile_bg.webp')";
    }
  };
});